import {Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgDataListComponent} from 'exc-controls-v2';
import {EnumerationService} from '../services/enumeration.service';
import {ApplicationService} from '../services/application.service';
import {CdkDragDrop, CdkDragMove, CdkDragStart, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {Observable} from 'rxjs';
import {ExgDropdownComponent} from '../misc/exg-dropdown/exg-dropdown.component';
import {DOCUMENT} from '@angular/common';

@Component({
  selector: 'app-reference-viewer',
  templateUrl: './viewer.component.html',
  styles: []
})
export class ViewerComponent extends ExcTranslation implements OnInit {
  /************************/
  @ViewChild('VCreceiptList', {read: ExgDataListComponent}) VCreceiptList!: ExgDataListComponent;
  @ViewChild('VCreferenceList', {read: ExgDataListComponent}) VCreferenceList!: ExgDataListComponent;
  @ViewChild('VCGroupDropDown', {read: ExgDropdownComponent}) VCGroupDropDown!: ExgDropdownComponent;
  /************************/
  @Input()
  Data!: { caseID: string, vorgID?: string };
  @Input()
  tabinstance?: any;
  /************************/
  listControl = {
    expandThreePointMenue: false,
    receipt: {
      allowSingleSelection: true,
      toggle(): void {
        this.allowSingleSelection = !this.allowSingleSelection;
        this.toastMessage(this.allowSingleSelection);
      },
      toastMessage: (single: boolean): void => {
        let msg = '';
        if (single) {
          msg = this.getRessource('SingleSelektion', {table: 'Belegliste'});
        } else if (!single) {
          msg = this.getRessource('MultiSelektion', {table: 'Belegliste'});
        }

        this.appSvc.toast.Message(msg, 'far fa-list', '');
      },
      itemConfig: (rcptItem?: any, groupID?: string): any => {
        return {
          singleSelect: this.listControl.receipt.allowSingleSelection,
          actions: false,
          click: () => {
            this.listControl.onRowSelect(rcptItem, 'default');
          },
          dbclick: () => {
            this.appSvc.Receipt.Checkview.OpenTab(rcptItem['rcptID']);
          },
          action: [
            {
              icon: 'far fa-inbox-in',
              visible: true,
              disabled: !this.listControl.receipt.allowSingleSelection,
              action: () => {
                if (!this.listControl.isSelected(rcptItem)) {
                  this.listControl.onRowSelect(rcptItem, 'default')
                }
              }
            }
          ]
        };
      }
    },
    reference: {
      allowSingleSelection: true,
      toggle(): void {
        this.allowSingleSelection = !this.allowSingleSelection;
        this.toastMessage(this.allowSingleSelection);
      },
      toastMessage: (single: boolean): void => {
        let msg = '';
        if (single) {
          msg = this.getRessource('SingleSelektion', {table: 'Referenzen'});
          this.referenceList.selected = [];
        } else if (!single) {
          msg = this.getRessource('MultiSelektion', {table: 'Referenzen'});
        }

        this.appSvc.toast.Message(msg, 'far fa-list', '');
      },
      itemConfig: (refItem?: any, refGroupId?: any): any => {
        return {
          singleSelect: this.listControl.reference.allowSingleSelection,
          actions: true,
          click: () => {
            this.listControl.onRowSelect(refItem, refGroupId);
          },
          dbclick: () => {
            this.appSvc.Receipt.Checkview.OpenTab(refItem['rcptID']);
          },
          action: [
            {
              icon: 'far fa-inbox-out',
              visible: true,
              disabled: !this.listControl.reference.allowSingleSelection,
              action: () => {
                if (!this.listControl.isSelected(refItem)) {
                  this.listControl.onRowSelect(refItem, refGroupId)
                }
                this.reference.Item.Delete(this.referenceList.selected, refGroupId)
              }
            }
          ]
        };
      }
    },
    isSelected: (receipt: any): boolean => {
      let rcptID: string = this.ddControl.getDragData(receipt)['rcptID']
      return this.referenceList.selected.filter(selection => selection.rcptID === rcptID).length > 0 || this.receiptList.selected.filter(selection => selection.rcptID === rcptID).length > 0
    },
    onRowSelect: (refItem: any, groupId?: string): void => {

      if (!groupId?.includes('default')) {
        this.referenceList.selected = this.listControl.select(this.referenceList.selected, refItem, this.listControl.reference.allowSingleSelection)
      } else if (groupId?.includes('default')) {
        this.receiptList.selected = this.listControl.select(this.receiptList.selected, refItem, this.listControl.receipt.allowSingleSelection)
      }
    },
    select(array: any[], item: any, singleSelect: boolean) {
      // If exists remove Selection in array
      if (ExcCoreModule.Array.ExistsObject(array, 'rcptID', item['rcptID'])) {
        ExcCoreModule.Array.RemoveObject(
          array,
          item)
        return array;
      }
      // Clear selection before new selection
      if (singleSelect) {
        array = [];
      }
      // new selection
      ExcCoreModule.Array.Add(
        array,
        item)
      return array;
    },
    visionControlToggle(group: any): void {
      if (group['#Items'] > 0) {
        group['isExpanded'] = !group['isExpanded'];
      }
    },
  }
  drawerControl = {
    receiptList: {
      visible: true,
      toggle(disabled = false): void {
        if (!disabled) {
          this.visible = !this.visible;
        }
      }
    },
  };
  /************************/
  referenceList = {
    selectKey_Item: 'refItemID',
    selectKey_Group: 'refGroupID',
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilter: [] as any[],
    uiSort: [
      {sortField: 'rcptCRD', sortDefault: 0, uiCaption: 'letzte Erstellung', uiValue: false},
      {sortField: 'rcptLCD', sortDefault: 0, uiCaption: 'letzte Änderung', uiValue: false}],
    dataItem: [] as any[],
    dataGroup: [] as any[],
    dataItems2: [] as any[],
    dataGroup2: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    dataReceipt: [] as any[],
    selected: [] as any[],
    pageChanged: (page: number) => {
      if (this.referenceList.MetaInfo.dataPaging !== undefined) {
        this.referenceList.MetaInfo.dataPaging.pageNo = page;
      }
      this.referenceList.loadData();
    },
    search: (value: string) => {
      this.referenceList.searchValue = value;
      this.referenceList.pageChanged(1);
    },
    ready: () => {
      if ((!this.referenceList.dataItem|| this.referenceList.dataItem.length === 0)
        || (!this.receiptList.data || this.receiptList.data.length === 0)
        || (!this.referenceList.dataGroup|| this.referenceList.dataGroup.length === 0) )  {
        this.referenceList.state = 2;
        this.receiptList.state = 2
        if (!this.drawerControl.receiptList.visible) {
          this.drawerControl.receiptList.visible = false;
        }
      } else {
        this.referenceList.state = 0;
        this.receiptList.state = 0
        this.drawerControl.receiptList.visible = true;
      }
    },
    isFiltered: () => {
      return (this.referenceList.uiFilter &&
        JSON.stringify({}) !== JSON.stringify(this.referenceList.MetaInfo.dataFilter));
    },
    loadDataItems(dataItems: any[]): void {
      this.dataItem = dataItems;
    },
    loadDataGroup2(dataGroupes: any[]): void {
      this.dataGroup2 = dataGroupes;
    },
    loadDataItems2(dataItems: any[]): void {
      this.dataItems2 = dataItems;
    },
    loadDataReceipt: (dataReceipt: any[]): void => {
      dataReceipt.forEach((rcpt: any) => {
        rcpt.expandThreePointMenue = false;
      });
      this.referenceList.dataReceipt = dataReceipt; // .filter((rcpt: any) => !rcpt.showInList);
      this.receiptList.loadData(dataReceipt.filter((rcpt: any) => rcpt.showInList));
    },
    loadDataGroup: (dataGrouped: any[]): void => {
      this.ddControl.connectedTo = [];
      this.ddControl.connectedTo.push('list-default-cdk-dropGroup')
      dataGrouped.sort(this.referenceList.rowSortCompare).forEach((grp: any) => {
        grp.refItems = grp.refItems ? JSON.parse(grp.refItems).sort(this.referenceList.rowSortCompare) : [];
        grp.expandThreePointMenue = false;
        grp.isExpanded = this.referenceList.dataGroup.length !== 0 && ExcCoreModule.Array.GetObject(this.referenceList.dataGroup, 'refGroupID', grp.refGroupID) ?
                                ExcCoreModule.Array.GetObject(this.referenceList.dataGroup, 'refGroupID', grp.refGroupID)['isExpanded']
                            : false;
        this.ddControl.connectedTo.push(`list-${grp['refGroupID']}`);
      });
      this.referenceList.dataGroup = dataGrouped;
    },
    loadData: (groupItems?: any, items?: any) => {
      const SELF = this;
      SELF.referenceList.state = 1;
      if (!(groupItems || items)) {
        SELF.excRest
          .get(
            SELF.excRest.computeUrl('ReferenceR_List', {
              fts: this.referenceList.searchValue,
              auID: this.Data.caseID,
              // vorgID: this.Data.vorgID
            }), {MetaInfo: SELF.referenceList.MetaInfo})
          .subscribe(
            (response: any) => {
              if (response.success && response.data) {
                SELF.referenceList.loadDataReceipt(response.data.Receipt);
                SELF.referenceList.loadDataItems(response.data.ReferenceItems);
                SELF.referenceList.loadDataGroup(response.data.ReferenceGroupItems);
                SELF.referenceList.loadDataItems2(response.data.refItem);
                SELF.referenceList.loadDataGroup2(response.data.refGroup);
              } else {
                SELF.referenceList.loadDataItems([]);
                SELF.referenceList.loadDataGroup([]);
                SELF.referenceList.loadDataReceipt([]);
              }
              SELF.referenceList.ready();
            }
          );
      } else {
        SELF.referenceList.loadDataItems(items);
        SELF.referenceList.loadDataGroup(groupItems);
        SELF.receiptList.ready();
      }
    },
    getReceiptObject(rcptID: string): any {
      return ExcCoreModule.Array.GetObject(
        this.dataReceipt, 'rcptID', rcptID.toLowerCase()
      );
    },
    rowSortCompare: (obj1: any , obj2: any) => {
      if (obj1['refItemSortOrder'] || obj2['refItemSortOrder']) {
        return obj1['refItemSortOrder'] - obj2['refItemSortOrder'];
      } else {
        return obj1['refGroupSortOrder'] - obj2['refGroupSortOrder'];
      }
    },
  };
  receiptList = {
    selectKey: 'rcptID',
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    selection:  [] as any[],
    selected: [] as any[],
    uiFilter: [] as any[],
    uiSort: [
      {sortField: 'rcptCRD', sortDefault: 0, uiCaption: 'letzte Erstellung', uiValue: false},
      {sortField: 'rcptLCD', sortDefault: 0, uiCaption: 'letzte Änderung', uiValue: false}],
    data: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},

    pageChanged: (page: number) => {
      if (this.receiptList.MetaInfo.dataPaging !== undefined) {
        this.receiptList.MetaInfo.dataPaging.pageNo = page;
      }
      this.receiptList.loadData();
    },
    search: (value: string) => {
      this.receiptList.searchValue = value;
      this.receiptList.pageChanged(1);
    },
    ready: () => {
      if (!this.receiptList.data || this.receiptList.data.length === 0) {
        this.receiptList.state = 2;
        this.drawerControl.receiptList.visible = false;
      } else {
        this.receiptList.state = 0;
        this.drawerControl.receiptList.visible = true;
      }
    },
    isFiltered: () => {
      return (this.receiptList.uiFilter &&
        JSON.stringify({}) !== JSON.stringify(this.receiptList.MetaInfo.dataFilter));
    },
    loadData: (data?: any) => {
      const SELF = this;
      SELF.receiptList.state = 1;
      if (!data) {
        SELF.excRest
          .get(
            SELF.excRest.computeUrl('ReceiptR_List', {
              fts: this.receiptList.searchValue,
              auID: this.Data.caseID,
              // vorgID: this.Data.vorgID
            }), {MetaInfo: SELF.receiptList.MetaInfo})
          .subscribe(
            (response: any) => {
              if (response.success && response.data && response.data.length > 0) {
                SELF.receiptList.loadData(response.data);
              } else {
                SELF.receiptList.data = [];
              }
              SELF.receiptList.ready();
            }
          );
      } else {
        SELF.receiptList.data = data;
        SELF.receiptList.ready();
      }
    },
  };
  /************************/
  ddControl = {
    dragDrop: false,
    dragging: false,
    dropAction: {
      targetId: '' as string,
      action: '',
    },
    connectedTo: ['list-default-cdk-dropGroup'] as  string[],
    getConnected(groupID: string) {
      return this.connectedTo.filter((item: string) => !item.includes(groupID));
    },
    getDragData: (receipt: any) => {
      if (receipt && receipt['rcptID']) {
        return receipt;
      }
      return this.referenceList.getReceiptObject(receipt['refItem_rcptID'])
    },
    eventHandler: {
      onDragStart: (event: CdkDragStart<any>): void => {
        this.ddControl.dragging = true;
        if (!this.listControl.isSelected(event.source.data)) {
          this.listControl.onRowSelect(event.source.data, event.source.dropContainer.id)
        }
      },
      onDrop: (event: CdkDragDrop<any>) => {
        this.ddControl.dragging = false;
        if (event.previousContainer === event.container) {
          moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
          if (event.container.id !== this.ddControl.connectedTo[0]) {
            this.reference.Item.Update(event.container.data, this.referenceList.selected, event.container.id.replace('list-',''));
          }
        } else {
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex);

          this.listControl.onRowSelect(event.item.data, event.previousContainer.id)
          this.listControl.onRowSelect(event.item.data, event.container.id)

          if (event.container.id === this.ddControl.connectedTo[0]) {
            this.reference.Item.Delete(this.receiptList.selected, event.previousContainer.id.replace('list-',''));
          } else if (event.container.id !== this.ddControl.connectedTo[0] && event.previousContainer.id === this.ddControl.connectedTo[0]) {
            this.reference.Item.Create(event.container.data, event.container.id.replace('list-',''));
          } else {
            this.reference.Item.Update(event.container.data, this.referenceList.selected, event.container.id.replace('list-',''));
          }
        }
      },
      onDragMoved: (event: CdkDragMove<any>) => {
        let e = this.document.elementFromPoint(event.pointerPosition.x,event.pointerPosition.y);

        if (!e) {
          this.ddControl.clearDragInfo();
          return;
        }
        let container = e.classList.contains("node-item") ? e : e.closest('.node-item');

        if (!container || !container.getAttribute('id') || !container?.getBoundingClientRect()) {
          return;
        }

        this.ddControl.dropAction['targetId'] = `${container.getAttribute('id')}`;
        let containerRec: { height: number; top: number };
        containerRec = e.getBoundingClientRect();

        if (event.pointerPosition.y <= containerRec.top && event.pointerPosition.y >= containerRec.top+containerRec.height) {
          // before
          this.ddControl.dropAction['action'] = "inside";
        }

      },
    },
    clearDragInfo(dropped: boolean = false): void {
      if (dropped) {
        this.dropAction = {targetId: '', action: ''};
      }
    },

    /**
     * Predicate function that only allows even numbers to be
     * sorted into even indices and odd numbers at odd indices.
     *
     * sortPredicate(index: number, item: CdkDrag<any>) {
     *   return item.data.refItemSortOrder;
     * }
     */
  }
  /************************/

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public excRest: ExcRestService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.referenceList.loadData();
  }

  reference = {
    sub: {
      prepCreate: (isGroup = true, data?: any): Observable<any> => {
        data.auID = this.Data.caseID;
        data.vorgID = this.Data.vorgID;

        return this.excRest.post(
          this.excRest.computeUrl(`Reference${!isGroup ? '_Item' : 'C_Group'}`)
          , data);
      },
      prepUpdate: (isGroup = true, refID?: string, data?: any): Observable<any> => {
        data.auID = this.Data.caseID;
        data.vorgID = this.Data.vorgID;

        return this.excRest.put(
          this.excRest.computeUrl(`Reference${!isGroup ? '_Item' : 'U_Group'}`,  refID ? {refID} : undefined)
          , data);
      },
      prepDelete: (isGroup = true, refID?: string, data?: any): Observable<any> => {
        data.auID = this.Data.caseID;
        data.vorgID = this.Data.vorgID;

        return this.excRest.delete(
          this.excRest.computeUrl(
            `Reference${!isGroup ? '_Item' : 'D_Group'}`,
            refID ? {refID} : undefined)
          , data);
      }
    },
    Group: {
      Create: () => {
        this.reference.sub.prepCreate(true, {})
          .subscribe((response: any) => {
            if (response) {
              if (response.sucess && response.data.ReferenceGroupItems) {
                this.referenceList.loadData(response.data.ReferenceItems, response.data.ReferenceGroupItems);
              } else {
                this.referenceList.loadData();
              }
            }
          });
      },
      Update: (groupID: string, groupUPT: string, data?: any) => {
        data.refGroupUPT = groupUPT;
        this.reference.sub.prepUpdate(true, groupID, data)
          .subscribe(
            (response: any) => {
              if (response) {
                if (response.sucess && response.data.ReferenceGroupItems) {
                  this.referenceList.loadData(response.data.ReferenceItems, response.data.ReferenceGroupItems);
                } else {
                  this.referenceList.loadData();
                }
              }
            });
      },
      Delete: (groupID: string, groupUPT: string) => {
        this.reference.sub.prepDelete(true, groupID, {refGroupUPT: groupUPT})
          .subscribe(
            (response: any) => {
              if (response) {
                this.referenceList.loadData();
              }
            });
      }
    },
    Item: {
      Create: (selected: any[], groupID?: string) => {
        let data: { refGroupID: any; receiptItem: any[] } = {
          refGroupID: groupID ? groupID : ExcCoreModule.Guid.NewGuid(),
          receiptItem: [] as any[]
        };

        if (selected.length > 0) {
          for (let selectedKey in selected) {
            let obj = this.ddControl.getDragData(selected[selectedKey]);
            ExcCoreModule.Array.Add(data.receiptItem,
              {
                refItemID: obj['rcptID'],
                refItemSortOrder: selectedKey,
                refItemUPT: obj['rcptUPT']
              });
          }
        }

        if (data && data.receiptItem.length > 0) {
          this.reference.sub.prepCreate(false, data)
            .subscribe(
              (response: any) => {
                if (response) {
                  this.referenceList.loadData();
                }
              });
        }
      },
      Update: (container: any[], selected: any[], groupID?: string) => {
        let data: { refGroupID: any; receiptItem: any[] } = {
          refGroupID: groupID && !groupID.includes('default') ? groupID : ExcCoreModule.Guid.NewGuid(),
          receiptItem: [] as any[]
        };

        if (selected.length > 0) {
          for (let selectedKey in container) {
            let obj = this.ddControl.getDragData(container[selectedKey]);
            ExcCoreModule.Array.Add(data.receiptItem,
              {
                refItemID: obj['rcptID'],
                refItemSortOrder: selectedKey,
                refItemUPT: obj['refItemUPT']
              });
          }
        }

        if (data && data.receiptItem.length > 0) {
          this.reference.sub.prepUpdate(false, undefined, data)
            .subscribe(
              (response: any) => {
                if (response) {
                  this.referenceList.loadData();
                }
              });
        }
      },
      Delete: (selected: any[], groupID?: string) => {
        let data: { refGroupID: any; receiptItem: any[] } = {
          refGroupID: groupID && !groupID.includes('default') ? groupID : ExcCoreModule.Guid.NewGuid(),
          receiptItem: [] as any[]
        };

        if (selected.length > 0) {
          for (let selectedKey in selected) {
            let obj = this.ddControl.getDragData(selected[selectedKey]);
            ExcCoreModule.Array.Add(data.receiptItem,
              {
                refItemID: obj['rcptID'],
                refItemSortOrder: selectedKey,
                refItemUPT: obj['refItemUPT']
              });
          }
        }

        this.reference.sub.prepDelete(false, undefined, data)
          .subscribe(
            (response: any) => {
              if (response) {
                this.referenceList.loadData();
              }
            });
      }
    },
  }
}
